import { render, staticRenderFns } from "./r-challenge-type.vue?vue&type=template&id=2b6fc712"
import script from "./r-challenge-type.vue?vue&type=script&lang=js"
export * from "./r-challenge-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b6fc712')) {
      api.createRecord('2b6fc712', component.options)
    } else {
      api.reload('2b6fc712', component.options)
    }
    module.hot.accept("./r-challenge-type.vue?vue&type=template&id=2b6fc712", function () {
      api.rerender('2b6fc712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/server-events/challenge/r-challenge-type.vue"
export default component.exports